import { HttpMethod } from '@nu-art/thunderstorm-shared';
export const ApiDef_EHRInstallation = {
    _v1: {
        getEHRInstallation: { method: HttpMethod.GET, path: '/v1/get-ehr-installation' },
        deleteInstallation: { method: HttpMethod.POST, path: '/v1/delete-installation' },
        copyOrderConfigsFromEHRInstallation: { method: HttpMethod.POST, path: '/v1/copy-order-configs-from-ehr-installation' },
    }
};
//# sourceMappingURL=api-def.js.map